import { useCallback, useEffect, useState } from 'react';
import { noop } from "@client/shared/constants";
import { toast } from 'react-toastify';
import Recorder from './recorder';
import Service from './service';
import RingoutPrerecorderView from './view';

const defaultState = {
  greeting: null,
  announmentOnlyList: [],
  phoneNumberList: [],
  recorderDialog: {
    open: false,
  },
  loaders: {
    announmentOnlyList: false,
    phoneNumberList: false,
    greeting: false,
  }
};

const RingoutPrerecorder = ({
  ringout = {},
  countryList = [],
  handleRingoutChange = noop
}) => {
  const [state, setState] = useState(defaultState);

  const fetchAnnounmentOnlyList = useCallback(async (extensionId) => {
    setState(prevState => ({
      ...prevState,
      loaders: {
        ...prevState.loaders,
        announmentOnlyList: true
      }
    }));
    const { data, error } = await Service.getAnnounmentOnlyList();

    if (error) {
      toast.error(Array.isArray(error) ? error[0]?.message : error);
    }

    setState(prevState => ({
      ...prevState,
      announmentOnlyList: data?.extensions || defaultState.announmentOnlyList,
      loaders: {
        ...prevState.loaders,
        announmentOnlyList: false
      }
    }));
    if (data?.extensions?.length === 1 && !extensionId) {
      handleRingoutChange('extension', data?.extensions[0]);
    }
    if (extensionId) {
      const extension = (data?.extensions || []).find(extension => extension.id === +extensionId)
      extension && handleRingoutChange('extension', extension, !!extensionId);
    }
  }, []);

  const fetchPhoneNumberList = useCallback(async (extensionId, isEdit = false) => {
    setState(prevState => ({
      ...prevState,
      loaders: {
        ...prevState.loaders,
        phoneNumberList: true
      }
    }));
    const { data, error } = await Service.getPhoneNumberList(extensionId);

    if (error) {
      toast.error(Array.isArray(error) ? error[0]?.message : error);
    }

    setState(prevState => ({
      ...prevState,
      phoneNumberList: data?.phoneNumbers || defaultState.phoneNumberList,
      loaders: {
        ...prevState.loaders,
        phoneNumberList: false
      }
    }));
    if (data?.phoneNumbers?.length === 1) {
      handleRingoutChange('extensionPhoneNumber', data?.phoneNumbers[0], true);
    }
  }, []);

  const fetchGreeting = useCallback(async (extensionId) => {
    setState(prevState => ({
      ...prevState,
      loaders: {
        ...prevState.loaders,
        greeting: true
      }
    }));
    let { data, error } = await Service.getAnsweringRule(extensionId);

    if (error) {
      toast.error(Array.isArray(error) ? error[0]?.message : error);
    }

    const greetings = (data || [])
    .filter(item => item.id === "business-hours-rule")
    .map(item => (item.greetings || []).filter(item => item.type === "Announcement" && item.custom))
    .flat();

    const greetingId = greetings[0]?.custom?.id;

    if (greetingId) {
      let { data, error } = await Service.getGreeting(extensionId, greetingId);
      error && toast.error(Array.isArray(error) ? error[0]?.message : error);
      setState(prevState => ({
        ...prevState,
        greeting: data || defaultState.greeting
      }));
    }

    setState(prevState => ({
      ...prevState,
      loaders: {
        ...prevState.loaders,
        greeting: false
      }
    }));
  }, []);


  useEffect(() => {
    fetchAnnounmentOnlyList(typeof ringout?.extension !== 'object' ? ringout?.extension : null );
  }, []);

  useEffect(() => {
    if (ringout.extension?.id) {
      fetchPhoneNumberList(ringout.extension.id, typeof ringout?.extension !== 'object');
      fetchGreeting(ringout.extension.id, typeof ringout?.extension !== 'object');
    }
  }, [ringout.extension]);

  return (
    <>
      <RingoutPrerecorderView
        extension={ringout.extension}
        extensionPhoneNumber={ringout.extensionPhoneNumber}
        announmentOnlyList={state.announmentOnlyList}
        phoneNumberList={state.phoneNumberList}
        phoneNumber={ringout.phoneNumber}
        phoneNumberError={ringout.phoneNumberError}
        greeting={state.greeting}
        loaders={state.loaders}
        countryList={countryList}
        handleRingoutChange={handleRingoutChange}
        openRecorderDialog={() => {
          setState(prevState => ({
            ...prevState,
            recorderDialog: {
              ...prevState.recorderDialog,
              open: true,
            }
          }))
        }}
      />
      {state.recorderDialog.open && (
        <Recorder
          open={state.recorderDialog.open}
          extensionId={ringout?.extension?.id}
          countryList={countryList}
          handleClose={(isChanged = false) => {
            setState(prevState => ({
              ...prevState,
              recorderDialog: defaultState.recorderDialog,
            }));
            if (isChanged) {
              fetchGreeting(ringout.extension.id);
            }
          }}
        />
      )}
    </>
  );
};

export default RingoutPrerecorder